import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FileDownloadRoundedIcon from "@mui/icons-material/FileDownloadRounded";
import Field from "../../../components/Field";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function ClaimantPersonalInformation(props: any) {
  const {
    claimantDetails,
    commentDetails,
    claimantCopy,
    handleClaimantCommentChange,
    claimantComment,
  } = props;
  const comments = commentDetails?.filter(
    (comment: any) => comment.section_type === "CLAIMANT_PERSONAL_INFORMATION"
  );
  return (
    <Grid container spacing={4} p={4} mt={5}>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field
          label="Claimant/Beneficiary's Employer"
          value={claimantDetails?.beneficiary_employer}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field label="Occupation" value={claimantDetails?.occupation} />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field label="Title" value={claimantDetails?.title} />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field label="Initials" value={claimantDetails?.initials} />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field label="Gender" value={claimantDetails?.gender} />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field label="Full name" value={claimantDetails?.first_name} />
      </Grid>

      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field
          label="Material status"
          value={claimantDetails?.marital_status}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field label="Nationality" value={claimantDetails?.nationality} />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field label="Date of birth" value={claimantDetails?.date_of_birth} />
      </Grid>

      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field
          label="ID/passport number"
          value={claimantDetails?.passport_number}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field
          label="Country of birth"
          value={claimantDetails?.country_of_birth}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field
          label="Country of residence"
          value={claimantDetails?.country_of_residence}
        />
      </Grid>

      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field label="Email" value={claimantDetails?.email} />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field
          label="Physical/Postal address"
          value={claimantDetails?.postal_address}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field label="Postal code" value={claimantDetails?.postal_code} />
      </Grid>

      <Grid size={{ xs: 12, sm: 12 }} textAlign="left">
        <Field
          label="Communication regarding the claim should take place with:"
          value="Employer"
        />
      </Grid>

      <Grid size={{ xs: 12, sm: 12 }} textAlign="left">
        <Field
          label="Source of funds with the following options:"
          value="Saving/Investments"
        />
      </Grid>
      {claimantCopy?.map((doc: any, index: any) => {
        return (
          <Grid size={{ xs: 12 }}>
            <Box width={270} height={48}>
              <Typography fontWeight={600} textAlign="left" fontSize={18}>
                Claimant's ID copy
              </Typography>
              <Box
                sx={{
                  background: "#F5EEE9",
                  color: "#FF0000",
                  borderRadius: 1,
                  px: 1.5,
                  py: 0.5,
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <PictureAsPdfIcon />
                <Box
                  display="flex"
                  justifyContent="center"
                  flexDirection="column"
                >
                  <Typography fontSize={14}>{doc.file_name}</Typography>
                </Box>
                <IconButton
                  onClick={() => window.open(doc.file_url, "_blank")}
                  size="small"
                >
                  <FileDownloadRoundedIcon />
                </IconButton>
              </Box>
            </Box>
          </Grid>
        );
      })}
      {comments?.length > 0 && (
        <Grid size={12} mt={4}>
          {comments.map((comment: any, index: number) => (
            <Accordion
              key={index}
              sx={{
                backgroundColor: "#F7F7F7",
                boxShadow: "none",
                borderRadius: "6px",
                mb: 2,
                border: "1px solid #E0E0E0",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel${index}-content`}
                id={`panel${index}-header`}
                sx={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box>
                  <Typography fontWeight={600} fontSize={14}>
                    {comment.commentedByName}{" "}
                    <Typography
                      component="span"
                      fontWeight={600}
                      color="#EC6E00"
                    >
                      - {comment.role_at_time_of_comment?.toUpperCase()}
                    </Typography>
                  </Typography>
                  <Typography fontSize={12} color="text.secondary">
                    {new Date(comment.created_on).toLocaleTimeString("en-US", {
                      hour: "numeric",
                      minute: "2-digit",
                    })}{" "}
                    |{" "}
                    {new Date(comment.created_on).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Typography
                  fontSize={15}
                  color="#333"
                  lineHeight={1.6}
                  textAlign="left"
                >
                  {comment.content}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Grid>
      )}
      <Grid size={{ md: 12 }} mt={4}>
        <Typography
          variant="body1"
          fontWeight={600}
          fontSize={18}
          sx={{ display: "block", textAlign: "left" }}
        >
          Comment
        </Typography>
        <TextField
          multiline
          rows={4}
          variant="outlined"
          fullWidth
          onChange={handleClaimantCommentChange}
          value={claimantComment}
        />
      </Grid>
    </Grid>
  );
}
